<div style="page-break-inside: avoid">
  <p class="table-title">בדיקת התקנת המערכת:</p>
  <ol class="inspections inspection-items" style="counter-set: item 1">
    <li>
      <span class="inspection-item">התקנה:</span>
      <ol style="break-inside: avoid">
        <li>
          <span class="case">פרטי הקבלן המבצע:</span>
          <table class="data-table">
            <thead>
              <tr>
                <th style="width: 33.3%">
                  <strong>שם הקבלן</strong>
                </th>
                <th style="width: 33.3%">
                  <strong>מס' טלפון</strong>
                </th>
                <th style="width: 33.3%">
                  <strong>מייל</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>{{ contractor?.name }}</span>
                </td>
                <td>
                  <span>{{ contractor?.phone }}</span>
                </td>
                <td>
                  <span>{{ contractor?.email }}</span>
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th style="width: 33.3%">
                  <strong>תפקיד</strong>
                </th>
                <th style="width: 33.3%">
                  <strong>כתובת</strong>
                </th>
                <th style="width: 33.3%">
                  <strong>ח.פ</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span>{{ contractor?.jobTitle }}</span>
                </td>
                <td>
                  <span>{{ contractor?.address }}</span>
                </td>
                <td>
                  <span>{{ contractor?.companyNumber }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </li>
      </ol>
    </li>
  </ol>
</div>
<ol
  class="inspections inspection-items"
  style="counter-set: item 2; margin-top: 20px"
>
  <li style="page-break-inside: avoid">
    <span class="inspection-item">התרעות לרכזת:</span>
    <table
      class="data-table"
      *ngIf="
        inspection?.sprinklerSystemInstallation?.alarmCheck?.hubModel ||
        inspection?.sprinklerSystemInstallation?.alarmCheck?.hubLocation
      "
    >
      <thead>
        <tr>
          <th style="width: 30%"><span>דגם רכזת הגילוי</span></th>
          <th style="width: 30%"><span>מיקום רכזת הגילוי</span></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <span>{{
              inspection?.sprinklerSystemInstallation?.alarmCheck?.hubModel
            }}</span>
          </td>
          <td>
            <span>{{
              inspection?.sprinklerSystemInstallation?.alarmCheck?.hubLocation
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </li>
  <li class="avoid-break" style="margin-top: 0">
    <ol style="counter-set: item 3">
      <li
        style="page-break-inside: avoid; counter-set: item 0"
        *ngIf="inspection?.sprinklerSystemInstallation?.alarmCheck?.addToReport"
      >
        <span class="case">רשימת האביזרים והכתובות:</span>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 33.3%">סוג האביזר</th>
              <th style="width: 33.3%">מיקום (כינוי)</th>
              <th style="width: 33.3%">כתובת האביזר</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let alarm of inspection?.sprinklerSystemInstallation?.alarmCheck
                  ?.alarms
              "
            >
              <td>
                <span>{{ alarm.accessory }}</span>
              </td>
              <td>
                <span>{{ alarm.nameAndLocation }}</span>
              </td>
              <td>
                <span>{{ alarm.address }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
      <li
        style="margin-top: 10px"
        [style.counter-set]="
          !inspection?.sprinklerSystemInstallation?.alarmCheck?.addToReport
            ? 'item ' + i
            : 'item' + (i + 1)
        "
        *ngFor="
          let note of inspection?.sprinklerSystemInstallation?.alarmCheck?.notes
            | filterBy : ['addNotesToReport'] : true;
          let i = index
        "
      >
        <strong style="display: table-cell">{{ note.notes }}</strong>
      </li>
    </ol>
  </li>
  <li style="page-break-inside: avoid">
    <span class="inspection-item">הסנקה</span>
    <strong style="padding-right: 33px; display: block">
      <span style="text-decoration-line: underline">מיקום ההסנקה:</span>
      <span>
        {{
          inspection?.sprinklerSystemInstallation?.pressureSystem?.location
            ?.value
        }}
      </span>
    </strong>
  </li>
  <li>
    <span style="page-break-inside: avoid; display: table-cell">
      <span class="inspection-item">נתוני בדיקת אופיין רשת </span>
      <strong style="display: table-cell; padding-right: 5px">
        (לפי נוהל מכ"ר 529):</strong
      >
      <p style="padding-right: 14px">
        <strong>ספיקה ולחץ שנמדדו לאחר המז"ח / אח"כ: </strong>
      </p>
      <p style="padding-right: 14px">
        <strong
          >האם מתאים לדרישות התכנון?
          {{ waterNetworkCharacterizationStatus }}</strong
        >
      </p>
    </span>

    <ol
      *ngIf="inspection?.waterNetworkCharacterization?.isApplicable"
      style="page-break-inside: avoid"
    >
      <li
        *ngFor="
          let item of inspection?.waterNetworkCharacterization?.testData
            | filterBy : ['isApplicable'] : true
        "
      >
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 33%"><span>שם הבודק</span></th>
              <th style="width: 33%"><span>תאריך הבדיקה</span></th>
              <th style="width: 33%"><span>שעת הבדיקה</span></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span>{{ item.testerName }}</span>
              </td>
              <td>
                <span>{{ inspectionDate | date : 'shortDate' : 'GMT+3' }}</span>
              </td>
              <td>
                <span>{{ item.testDateTime }}</span>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="data-table" style="margin-top: 20px">
          <tbody>
            <tr>
              <td style="background-color: #ecf0f1; width: 33.3%">
                <span>מיקום מדידת לחצים</span>
              </td>
              <td>
                <span>{{ item.pressureMeasurementLocation }}</span>
              </td>
            </tr>
            <tr>
              <td style="background-color: #ecf0f1">
                <span>מיקום מדידת ספיקה</span>
              </td>
              <td>
                <span> {{ item.flowMeasurementLocation }}</span>
              </td>
            </tr>
            <tr>
              <td style="background-color: #ecf0f1">
                <span>קוטר צינור אספקת מים</span>
              </td>
              <td>
                <span> {{ item.waterSupplyPipeDiameter }}</span>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <authority-labs-water-supply-chart
          [staticPressure]="item.staticPressure"
          [residualPressure]="item.residualPressure"
          [totalFlow]="item.flowRate"
          [systemFlow]="item.systemFlow"
          [systemDemand]="item.systemDemand"
        ></authority-labs-water-supply-chart>

        <ol class="notes">
          <li *ngFor="let note of item.notes">
            <strong>{{ note.notes }}</strong>
          </li>
        </ol>
      </li>
    </ol>
  </li>

  <li>
    <span class="inspection-item">הערות נוספות על ידי המעבדה:</span>
    <ol class="notes">
      <li>
        <strong>הבדיקה מתיחסת לאזורים המסומנים ע"ג התוכניות בלבד.</strong>
      </li>
      <li *ngFor="let note of notes" style="page-break-inside: avoid">
        <strong>{{ note }}</strong>
      </li>

      <li
        style="page-break-inside: avoid"
        *ngFor="
          let item of inspection?.pumpRoomInstallation?.pumps
            | filterBy : ['isApplicable'] : true;
          let i = index
        "
      >
        <strong class="case" style="display: block">משאבה {{ i + 1 }}:</strong>
        <ol class="notes">
          <li *ngFor="let note of item.getNotes()">
            <strong>{{ note.notes }}</strong>
          </li>
          <li
            *ngIf="item?.waterFlowData?.isApplicable"
            style="page-break-inside: avoid"
          >
            <strong class="case" style="display: block"
              >להלן תוצאות בדיקת המשאבה:</strong
            >
            <table class="data-table water-test" style="margin: 10px 0">
              <thead>
                <tr>
                  <th style="width: 33.3%">ספיקה GPM</th>
                  <th style="width: 33.3%">לחץ מוצהר PSI</th>
                  <th style="width: 33.3%">לחץ מדוד PSI</th>
                </tr>
              </thead>
              <tbody dir="ltr">
                <tr>
                  <td>
                    <span>ללא זרימה</span>
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressureClosedTap
                          ?.declaredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressureClosedTap
                          ?.measuredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span
                      >{{
                        addMetric(
                          item?.waterFlowData?.flowAndPressure100?.flowRate,
                          'gpm'
                        )
                      }}-100%</span
                    >
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressure100
                          ?.declaredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressure100
                          ?.measuredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <span
                      >{{
                        addMetric(
                          item?.waterFlowData?.flowAndPressure150?.flowRate,
                          'gpm'
                        )
                      }}-150%</span
                    >
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressure150
                          ?.declaredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                  <td>
                    <span>{{
                      addMetric(
                        item?.waterFlowData?.flowAndPressure150
                          ?.measuredPressure,
                        'psi'
                      )
                    }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            <ol class="notes">
              <li *ngFor="let note of item?.waterFlowData?.notes">
                <strong>{{ note.notes }}</strong>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li
        style="page-break-inside: avoid"
        *ngFor="
          let item of inspection?.summaryNotes
            | filterBy : ['addNotesToReport'] : true
        "
      >
        <strong>{{ item.notes }}</strong>
        <ol class="notes">
          <li
            *ngFor="
              let subNote of item.subNotes
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong style="display: table-cell">{{ subNote.notes }}</strong>
          </li>
        </ol>
      </li>
    </ol>
  </li>
  <li style="page-break-inside: avoid">
    <span class="inspection-item"
      >כללי: כל שינוי מאופן ההתקנה שאושרה מחייב בדיקה חוזרת של תכנון והתקנת
      המערכת.</span
    >
    <section>
      <ng-content></ng-content>
    </section>
  </li>
</ol>
